import styled from "@emotion/styled";
export const StyledTemplatePageTabs = styled.div`
  .tabs-component.template-page-tabs-component {
    width: 100%;
    max-width: 990px;

    .tabs {
      justify-content: flex-start;

      .tab-component {
        min-width: 0;
        flex-grow: 1;

        .tab-label {
          color: #676879;
        }

        &:not(.active) {
          .tab-label {
            font-weight: 300;
          }
        }

        .tab-underline-placeholder {
          height: 3px;
        }
      }
    }
  }
`;
